import { Component, OnInit, Input, ViewChild, EventEmitter, Output} from '@angular/core';
import { AdminService } from 'src/app/services/admin.service';
import { QuestionsComponent } from '../questions/questions.component';

@Component({
  selector: 'app-form-product',
  templateUrl: './form-product.component.html',
  styleUrls: ['./form-product.component.scss']
})
export class FormProductComponent implements OnInit {
  @Input() productSelected: any;
  @ViewChild( QuestionsComponent ) questions!: QuestionsComponent;
  @Output() nextStepParent = new EventEmitter<boolean>(false);

  constructor(
    private adminservice: AdminService
  ) { }

  ngOnInit() {
  }

  registerQuestions(){
    this.questions.registerQuestions();
  }

  nextStepForm(event:any){
    this.nextStepParent.emit(event)
  }

}
